import { Component, input, InputSignal } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { DurationPipe } from 'src/app/pipes/duration.pipe';

@Component({
  selector: 'app-regular-main',
  standalone: true,
  imports: [
    TranslateModule,
    DurationPipe
  ],
  templateUrl: './regular-main.component.html',
  styleUrls: ['./regular-main.component.scss'],
})
export class RegularMainComponen {
  public title: InputSignal<string> = input<string>(); // TODO: CAMBIAR A OBJETO DE TRADUCCIONES
  public durationMinutes: InputSignal<number> = input<number>();
  public isDuration15Minutes: InputSignal<boolean> = input<boolean>();

}
